import { UserMinus } from 'lucide-react';
import { useDataProvider } from 'ra-core';
import { type AdminDataProvider } from '../../../api/adminDataProvider';
import { CustomBulkAction } from '../../Moonstar/CustomBulkAction';

export const BulkRemoveKpiAssignees = ({ kpiId }: { kpiId: number }) => {
  const dataProvider = useDataProvider<AdminDataProvider>();

  return (
    <CustomBulkAction
      mutationFn={(unitIds) =>
        dataProvider.removeKpiAssignees({
          data: unitIds.map((unitId) => ({
            kpiId,
            unitId,
          })),
        })
      }
      label="ra.action.remove"
      variant="destructive"
      buttonIcon={<UserMinus />}
      successMessage="moonstar.kpiAssignees.remove.successMessage"
    />
  );
};
